(() => {
  const BUTTON_TEXT = 'LINEやSNSでeギフトを贈る';
  const NOTE_TEXT = '住所を知らなくてもOK';
  const ROOT_SELECTOR = '[data-anygift="ProductPageGiftUi"]';
  const BUTTON_SELECTOR = '.anygift-e-gift-modal__open-button';

  const replaceButtonText = (button) => {
    if (!button) return;

    const walker = document.createTreeWalker(
      button,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          return node.textContent.trim()
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );

    const textNode = walker.nextNode();

    if (textNode) {
      if (textNode.textContent.trim() !== BUTTON_TEXT) {
        textNode.textContent = BUTTON_TEXT;
      }
    } else if (button.textContent.trim() !== BUTTON_TEXT) {
      button.textContent = BUTTON_TEXT;
    }
  };

  const addNote = (root, button) => {
    if (!root || !button || root.querySelector('.cradri-anygift-note')) return;

    const note = document.createElement('p');
    note.className = 'cradri-anygift-note';
    note.textContent = NOTE_TEXT;
    button.insertAdjacentElement('afterend', note);
  };

  const enhanceAnyGiftUi = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      const button = root.querySelector(BUTTON_SELECTOR);
      if (!button) return;

      replaceButtonText(button);
      addNote(root, button);
      document.documentElement.classList.add('cradri-anygift-ready');
    });
  };

  enhanceAnyGiftUi();

  const observer = new MutationObserver(enhanceAnyGiftUi);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
